<template>
	<div class="notifications">
		<div v-for="(notification, index) in visibleNotifications" :key="index" class="notification slideDown" :class="[notification.status]" :style="computeStyle(notification)">
			<div v-if="notification.title" class="notification__header" v-html="notification.title"></div>
			<div v-if="notification.message" class="notification__content" v-html="notification.message"></div>
		</div>
	</div>
</template>

<script>
	import defaultMixin from "@/mixins/default";
	export default {
		mixins: [defaultMixin],
		methods: {
			computeStyle(notification) {
				if (!notification.relativeTo) return null;
				const relativeElement = document.querySelector(notification.relativeTo);
				if (!relativeElement) return null;

				const rect = relativeElement.getBoundingClientRect();

				return {
					top: rect.top - 80 + "px",
					left: rect.left + "px",
				}
			}
		},
		computed: {
			visibleNotifications() {
				return this.hub.ui.notificationCenter.stack.filter(notification => {
					return notification.isVisible;
				});
			}
		}
	}
</script>